import React from 'react';

const RefundPolicy = () => {
  return (
    <div className="bg-white pl-4 pt-2 font-medium pb-6 m-5">
      <h1 className="text-3xl font-bold flex justify-center mb-6">Zittle Refund & Cancellation Policy</h1>
      <div className="mb-4 space-y-4">
        <p className="text-md">
          At Zittle, we aim to offer organizers full control over their bookings. Here&apos;s how
          cancellations and refunds are handled:
        </p>
        <div>
          <h2 className="text-xl font-bold my-2">For Organizers (Zittle Users) Subscription Refunds:</h2>
          <ul className="list-disc ml-4">
            <li>Zittle subscriptions are non-refundable once payment is made.</li>
            <li>
              You may cancel your subscription anytime; access will remain active until the end of your
              billing period. No partial refunds are issued for unused time.
            </li>
            <li>
              <b>Event Cancellations by Organizers:</b> If you cancel an event, it is your responsibility to
              inform participants and issue refunds (as per your own policy). Zittle does not automatically
              process refunds on behalf of organizers.
            </li>
          </ul>
        </div>
        <div>
          <h2 className="text-xl font-bold my-2">For Participants (Booking Through Zittle)</h2>
          <ul className="list-disc ml-4">
            <li>
              Zittle is a platform that helps organizers manage bookings — each organizer sets their own
              refund and cancellation terms.
            </li>
            <li>Please refer to the event page or contact the organizer directly for refund eligibility.</li>
            <li>
              If you face issues contacting an organizer, you can reach out to us at support@zittle.in, and
              we’ll try to assist.
            </li>
            <li>
              <b>Technical Issues or Failed Transactions</b> If your payment is successful but the booking
              doesn&apos;t reflect, please email us at support@zittle.in within 48 hours. We will verify and
              process a full refund if applicable. The refund would be credited in 7-10 business days.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
